import {GET_ANNUALPREVIOUS} from '../Actions/types'

const initialState= { 
    previousMonthsInYear: null,

}

export default function (state = initialState, action) {

        switch(action.type) {
            case GET_ANNUALPREVIOUS: 
                return{
                    ...state,
                    previousMonthsInYear: action.payload
                };
                default: 
            return state;

        }
    }



// WEBPACK FOOTER //
// ./src/Reducers/PreviousAnnualChartReducer.js